/* Conteúdo das instalações — altere os requires ao reorganizar as fotos. */

export const COMODIDADES = [
  {
    slug: "recepcao",
    titulo: "Recepção",
    tituloHero: "Recepção acolhedora",
    resumo:
      "Atendimento 24 horas em um ambiente pensado para o seu conforto desde o primeiro momento.",
    introducao:
      "A área de recepção do Hotel Marechal Express foi desenhada para transmitir tranquilidade após a viagem. Nossa equipe está disponível em todos os horários para check-in, informações sobre a cidade, suporte à reserva e tudo o que precisar durante a estadia.",
    imagens: [
      require("../../assets/imagens/estrutura/recepcao1.png"),
      require("../../assets/imagens/estrutura/recepcao2.png"),
      require("../../assets/imagens/estrutura/recepcao3.png"),
    ],
    destaques: [
      "Atendimento contínuo, inclusive feriados",
      "Orientação sobre Laranjeiras do Sul e região",
      "Check-in e check-out com cordialidade",
      "Espaço amplo e bem iluminado",
    ],
    blocos: [
      {
        titulo: "Primeira impressão que importa",
        texto:
          "Queremos que você se sinta recebido, não apressado. O balcão e o estar da recepção convidam a um momento de pausa antes de seguir para o quarto.",
      },
      {
        titulo: "Suporte durante toda a estadia",
        texto:
          "Chamadas, mensagens ou presencialmente: estamos à disposição para solicitações de serviço, segunda toalha, informações de trânsito ou indicações de comércio local.",
      },
    ],
    notaDestaque: null,
  },
  {
    slug: "descanso",
    titulo: "Espaço de descanso",
    tituloHero: "Ambiente para relaxar",
    resumo:
      "Área comum tranquila para leitura, um café ou simplesmente desacelerar entre um compromisso e outro.",
    introducao:
      "Dispomos de um espaço dedicado ao descanso dos hóspedes — pensado para o bem-estar e a convivência leve, sem uso como sala de reuniões. É o lugar ideal para uma conversa, esperar um transfer ou recarregar as energias antes da próxima etapa da viagem.",
    imagens: [
      require("../../assets/imagens/estrutura/descanso4.png"),
      require("../../assets/imagens/estrutura/recepcao3.png"),
      require("../../assets/imagens/estrutura/descanso3.png"),
    ],
    destaques: [
      "Ambiente silencioso e climatizado",
      "Poltronas e mobiliário confortável",
      "Wi‑Fi disponível na área comum",
      "Momento de pausa entre viagem e quarto",
    ],
    blocos: [
      {
        titulo: "Respiro no meio do dia",
        texto:
          "Seja a trabalho ou a lazer, um espaço calmo faz diferença. Aqui você encontra privacidade respeitada e um clima familiar, típico do Marechal Express.",
      },
      {
        titulo: "Para toda a família",
        texto:
          "Crianças e adultos podem utilizar o espaço com comodidade. É também um ponto de encontro antes de sair para jantar ou passeios.",
      },
    ],
    notaDestaque: null,
  },
  {
    slug: "cafe-da-manha",
    titulo: "Café da manhã",
    tituloHero: "Café da manhã incluído",
    resumo: "Comece o dia com variedade regional e itens quentes e frios, no conforto do hotel.",
    introducao:
      "O café da manhã está incluso na diária e é servido em salão dedicado, com mesas espaçosas e iluminação natural. Selecionamos produtos frescos, opções doces e salgadas e bebidas quentes para agradar diferentes paladares — do viajante apressado ao hóspede que prefere saborear com calma.",
    imagens: [
      require("../../assets/imagens/estrutura/lanchonete1.png"),
      require("../../assets/imagens/estrutura/lanchonete2.png"),
      require("../../assets/imagens/estrutura/lanchonete3.png"),
    ],
    destaques: [
      "Incluso na diária da hospedagem",
      "Opções quentes e frias, frutas e pães",
      "Ambiente higienizado e organizado",
      "Horário informado na recepção no check-in",
    ],
    blocos: [
      {
        titulo: "Energia para o seu roteiro",
        texto:
          "Sabemos que um bom café faz toda a diferença antes de longos trajetos ou reuniões. Por isso mantemos o buffet cuidado e reposto com frequência.",
      },
      {
        titulo: "Cuidado com restrições",
        texto:
          "Se você tiver alguma necessidade alimentar específica, informe na reserva ou na recepção; faremos o possível para orientá-lo quanto às opções disponíveis no dia.",
      },
    ],
    notaDestaque: null,
  },
  {
    slug: "garagem",
    titulo: "Garagem",
    tituloHero: "Garagem fechada e acesso 24 horas",
    resumo:
      "Estacionamento exclusivo para hóspedes, com garagem fechada, portão eletrônico e área parcialmente coberta — apoio da recepção a qualquer hora.",
    introducao:
      "Disponibilizamos garagem fechada para veículos dos hóspedes, com portão eletrônico e perímetro delimitado para maior segurança. Parte da área é parcialmente coberta, o que ajuda a proteger o carro em dias de chuva ou sol forte, sem ser uma cobertura integral em todo o pátio. A recepção permanece aberta 24 horas para orientação, liberação de acesso quando necessário e suporte durante a sua estadia.",
    imagens: [
      require("../../assets/imagens/estrutura/evento1.png"),
      require("../../assets/imagens/estrutura/evento2.png"),
      require("../../assets/imagens/estrutura/evento3.png"),
    ],
    destaques: [
      "Garagem fechada com portão eletrônico",
      "Área parcialmente coberta",
      "Uso prioritário para hóspedes durante a estadia",
      "Recepção e atendimento 24 horas para apoio e acesso",
    ],
    blocos: [
      {
        titulo: "Segurança e acesso controlado",
        texto:
          "O fechamento com portão eletrônico restringe a entrada ao perímetro da garagem. Combine com a recepção a melhor forma de entrar e sair, principalmente em horários de chegada ou partida fora do padrão — estamos disponíveis o dia todo.",
      },
      {
        titulo: "Cobertura parcial e planejamento",
        texto:
          "Como a cobertura é parcial, parte das vagas fica mais exposta ao tempo. Se preferir estacionar na área mais protegida, pergunte na recepção sobre a disponibilidade no momento. Para veículos altos, reboques ou manobras especiais, avise com antecedência para orientarmos o melhor posicionamento.",
      },
    ],
    notaDestaque: {
      titulo: "Resumo da garagem",
      texto:
        "Garagem fechada (não é estacionamento aberto na rua), com portão eletrônico, área parcialmente coberta e atendimento da recepção 24 horas para dúvidas, acesso e suporte durante toda a hospedagem.",
    },
  },
];

export function getComodidadeBySlug(slug) {
  return COMODIDADES.find((c) => c.slug === slug) ?? null;
}

export function getOutrasComodidades(slugAtual) {
  return COMODIDADES.filter((c) => c.slug !== slugAtual);
}
